import React, { Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import { createBrowserHistory } from 'history';
import { Mount, GTM, Hotjar } from 'env'

import 'assets/main.css'

import { QrcodeStores, WppStores, WppConfirmationStores } from './qrcode-stores';

import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme/custom';

const AsyncPage = ({ page, alternateFlow = 1, vwoKey = '_vis_opt_exp_1_combi' }) => {
    const Component = React.lazy(() => import(`./steps-${alternateFlow}/${page}`),)
    return <Suspense fallback={<span></span>}><Component vwoKey={vwoKey} /></Suspense>
}

const AsyncAuthPage = ({ page }) => {
    const Component = React.lazy(() => import(`./inspection-auth/${page}`),)
    return <Suspense fallback={<span></span>}><Component /></Suspense>
}

const InspectionAuthUserInformation = () => <AsyncAuthPage page={'01-user-information.jsx'} />
const InspectionAuthUserConfirmation = () => <AsyncAuthPage page={'02-user-confirmation.jsx'} />
const InspectionAuthResult = () => <AsyncAuthPage page={'03-result.jsx'} />

const Vehicles = () => <AsyncPage page={'01-vehicles.jsx'} alternateFlow={1} />
const Venues = () => <AsyncPage page={'05-venues.jsx'} alternateFlow={1} />
const PersonalInfo = () => <AsyncPage page={'10-personal-info.jsx'} alternateFlow={1} />
const Wait = () => <AsyncPage page={'30-wait.jsx'} alternateFlow={1} />
const Appointment = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={1} />
const Cancellation = () => <AsyncPage page={'06-cancellation.jsx'} />
const CancellationReason = () => <AsyncPage page={'07-cancellation-reason.jsx'} alternateFlow={1} />
const Cancelled = () => <AsyncPage page={'50-cancelled.jsx'} alternateFlow={1} />
const NotFound = () => <AsyncPage page={'999-not-found.jsx'} alternateFlow={1} />
// const Calculator = () => <AsyncPage page={'03-calculator.jsx'} alternateFlow={1} />
const CalculatorConfirmAppointment = () => <AsyncPage page={'03-calculator-confirm-appointment.jsx'} alternateFlow={1} />

const Vehicles2 = () => <AsyncPage page={'01-vehicles.jsx'} alternateFlow={2} />
const Venues2 = () => <AsyncPage page={'05-venues.jsx'} alternateFlow={2} />
const PersonalInfo2 = () => <AsyncPage page={'10-personal-info.jsx'} alternateFlow={2} />
const Wait2 = () => <AsyncPage page={'30-wait.jsx'} alternateFlow={2} />
const Appointment2 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={2} />
const CalculatorConfirmAppointment2 = () => <AsyncPage page={'03-calculator-confirm-appointment.jsx'} alternateFlow={2} />
const Cancellation2 = () => <AsyncPage page={'06-cancellation.jsx'} alternateFlow={2} />
const Cancelled2 = () => <AsyncPage page={'50-cancelled.jsx'} alternateFlow={2} />
const CancellationReason2 = () => <AsyncPage page={'07-cancellation-reason.jsx'} alternateFlow={2} />

const Vehicles3 = () => <AsyncPage page={'01-vehicles.jsx'} alternateFlow={3} />
const Venues3 = () => <AsyncPage page={'venues/05-venues.jsx'} alternateFlow={3} />
const PersonalInfo3 = () => <AsyncPage page={'10-personal-info.jsx'} alternateFlow={3} />
const Wait3 = () => <AsyncPage page={'30-wait.jsx'} alternateFlow={3} />
const Appointment3 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} />
const Appointment10 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_10_combi' />
const Appointment11 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_11_combi' />
const Appointment12 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_12_combi' />
const Appointment13 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_13_combi' />
const Appointment14 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_14_combi' />
const Appointment15 = () => <AsyncPage page={'40-appointment.jsx'} alternateFlow={3} vwoKey='_vis_opt_exp_15_combi' />
// const CalculatorConfirmAppointment3 = () => <AsyncPage page={'03-calculator-confirm-appointment.jsx'} alternateFlow={3} />
const Cancellation3 = () => <AsyncPage page={'06-cancellation.jsx'} alternateFlow={3} />
const Cancelled3 = () => <AsyncPage page={'50-cancelled.jsx'} alternateFlow={3} />
const CancellationReason3 = () => <AsyncPage page={'07-cancellation-reason.jsx'} alternateFlow={3} />
// const history = createBrowserHistory({ basename: '/funil' });

const Appointment4 = () => <AsyncPage page={'41-appointment-no-calculator.jsx'} alternateFlow={3} />

GTM()
Hotjar()

Mount(<ChakraProvider resetCSS theme={theme}><App /></ChakraProvider>)

function App() {
    return (
        <Router forceRefresh={true} basename="/funil" >
            <div>
                <Switch>
                    <Route path="/auth-user-information" render={InspectionAuthUserInformation} />
                    <Route path="/auth-user-confirmation" render={InspectionAuthUserConfirmation} />
                    <Route path="/auth-result" render={InspectionAuthResult} />

                    <Route exact path="/vistoria-carro-1" render={Vehicles} />
                    <Route exact path="/vistoria-info-1" render={PersonalInfo} />
                    <Route exact path="/vistoria-venue-1" render={Venues} />
                    <Route exact path="/vistoria-agendamento-1" render={Wait} />
                    <Route exact path="/vistoria-agendada-1" render={Appointment} />
                    <Route exact path="/vistoria-calculadora-1" render={CalculatorConfirmAppointment} />
                    <Route exact path="/vistoria-cancelada-1" component={Cancellation} />
                    <Route exact path="/vistoria-cancelamento-motivo-1" component={CancellationReason} />
                    <Route exact path="/vistoria-cancelamento-realizado-1" component={Cancelled} />

                    <Route exact path="/vistoria-qrcode-lojas" render={QrcodeStores} />
                    <Route exact path="/vistoria-wpp-lojas" render={WppStores} />
                    <Route exact path="/vistoria-confirmacao-wpp" render={WppConfirmationStores} />

                    <Route exact path="/vistoria-carro-2" render={Vehicles2} />
                    <Route exact path="/vistoria-info-2" render={PersonalInfo2} />
                    <Route exact path="/vistoria-venue-2" render={Venues2} />
                    <Route exact path="/vistoria-agendamento-2" render={Wait2} />
                    <Route exact path="/vistoria-calculadora-2" render={CalculatorConfirmAppointment2} />
                    <Route exact path="/vistoria-agendada-2" render={Appointment2} />
                    <Route exact path="/vistoria-preco-2" render={CalculatorConfirmAppointment2} />
                    <Route exact path="/vistoria-cancelada-2" component={Cancellation2} />
                    <Route exact path="/vistoria-cancelamento-motivo-2" component={CancellationReason2} />
                    <Route exact path="/vistoria-cancelamento-realizado-2" component={Cancelled2} />

                    <Route exact path="/vistoria-carro-3" render={Vehicles3} />
                    <Route exact path="/vistoria-info-3" render={PersonalInfo3} />
                    <Route exact path="/vistoria-venue-3" render={Venues3} />
                    <Route exact path="/vistoria-agendamento-3" render={Wait3} />
                    <Route exact path="/vistoria-agendada-3" render={Appointment3} />
                    <Route exact path="/vistoria-agendada-10" render={Appointment10} />
                    <Route exact path="/vistoria-agendada-11" render={Appointment11} />
                    <Route exact path="/vistoria-agendada-12" render={Appointment12} />
                    <Route exact path="/vistoria-agendada-13" render={Appointment13} />
                    <Route exact path="/vistoria-agendada-14" render={Appointment14} />
                    <Route exact path="/vistoria-agendada-15" render={Appointment15} />
                    <Route exact path="/vistoria-agendada-4" render={Appointment4} />
                    <Route exact path="/vistoria-cancelada-3" component={Cancellation3} />
                    <Route exact path="/vistoria-cancelamento-motivo-3" component={CancellationReason3} />
                    <Route exact path="/vistoria-cancelamento-realizado-3" component={Cancelled3} />

                    <Route render={NotFound} />
                </Switch>
            </div>
        </Router>
    )
}

